export default function navigateToHome() {
    window.location.assign(`${window.location.origin}/`);
}